//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from "../../lib/util";
import fileTypes from "../../lib/FileTypes";
import ImageList from "../../components/ImageList";
import ImageUploader from "../../components/ImageUploader";
import Util from "../../lib/util";

export default {
  name: "pc-download",
  components: {ImageList, ImageUploader},
  data() {
    return {
      roomOwnerId: 0,
      files: [],
      downloadUrl: util.ApiUrl + 'file/download/',
      imageFiles: []
    }
  },
  methods: {
    getPropertyCertificateFiles() {
      this.imageFiles = []
      abp.ajax.get('/api/services/app/NewOwner/GetPropertyCertificateFiles', {params: {roomOwnerId: this.roomOwnerId}}).then(res => {
        this.files = [];
        this.files = res.data.result;
        if (this.files.length > 0) {

          for (let i = 0; i < this.files.length; i++) {
            let item = this.files[i];
            let fileType = fileTypes.getFileType(item.contentType);
            let downloadUrl = this.downloadUrl + item.fileId;
            item.remoteUrl =
                `${Util.ApiUrl}file/download/${item.fileId}`;
            item.remoteThumbnailUrl =
                `${Util.ApiUrl}file/download/${item.fileId}?/1/w/100/h/100`;
            if (fileType.type === "image") {
              this.imageFiles.push(item);
            }
          }
        }
      })

      console.log(this.imageFiles)
    },
    handleDownLoad(item) {
      window.open(this.downloadUrl + item.fileId)
    },

    isImage(mime) {
      let fileType = fileTypes.getFileType(mime)
      if (fileType.type === "image") {
        return true
      } else {
        return false;
      }
    }
  },
  created() {
    this.roomOwnerId = this.$route.params.roomOwnerId;

    this.getPropertyCertificateFiles()
  }
}
